import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const API = process.env.REACT_APP_API_URL || "http://localhost:8080";

const ICONS = [
  "fa-building", "fa-star", "fa-industry", "fa-medkit",
  "fa-graduation-cap", "fa-home", "fa-car", "fa-tint",
  "fa-window-maximize", "fa-leaf", "fa-bug", "fa-paint-brush",
];

const ServicesDirectory = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  useEffect(() => {
    fetch(`${API}/?url=seo/pages&_t=${Date.now()}`)
      .then((r) => r.json())
      .then((data) => setPages(Array.isArray(data) ? data.filter((p) => p.is_active == 1) : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Helmet>
        <title>All Cleaning Services Christchurch | Clear &amp; Clean</title>
        <meta name="description" content="Browse all professional cleaning services offered by Clear & Clean in Christchurch — office, carpet, window, floor, building wash, pest control and more." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.clearandclean.co.nz/all-services" />
      </Helmet>

      {/* Hero */}
      <section
        className="hero-wrap hero-wrap-2"
        style={{ backgroundImage: 'url("/images/service_2.jpg")' }}
        data-stellar-background-ratio="0.5"
      >
        <div className="overlay" />
        <div className="container">
          <div className="row no-gutters slider-text align-items-end">
            <div className="col-md-9  pb-5">
              <p className="breadcrumbs mb-2">
                <span className="mr-2">
                  <Link to="/">Home <i className="fa fa-chevron-right" /></Link>
                </span>
                <span>All Services <i className="fa fa-chevron-right" /></span>
              </p>
              <h1 className="mb-0 bread">All Cleaning Services</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Tiles */}
      <section className="ftco-section">
        <div className="container">
          <div className="row justify-content-center pb-4">
            <div className="col-md-8 text-center ">
              <span className="subheading">What We Offer</span>
              <h2>Our Cleaning Services in Christchurch</h2>
              <p style={{ color: "#666", fontSize: "15px" }}>
                Click on any service below to learn more and get a free quote.
              </p>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-secondary" />
            </div>
          ) : pages.length === 0 ? (
            <p className="text-center text-muted">No services found.</p>
          ) : (
            <div className="row">
              {pages.map((page, i) => (
                <div
                  key={page.id}
                  className="col-sm-6 col-lg-4 mb-4 "
                  onClick={() => navigate(`/${page.slug}`)}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    style={{
                      background: "#fff",
                      border: "1px solid #eee",
                      borderRadius: 10,
                      padding: "2rem 1.5rem",
                      height: "100%",
                      transition: "box-shadow .2s, transform .2s",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = "0 8px 28px rgba(0,0,0,.12)";
                      e.currentTarget.style.transform = "translateY(-4px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = "none";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <div
                      style={{
                        width: 64, height: 64, borderRadius: "50%",
                        background: "#1a1a1a", display: "flex",
                        alignItems: "center", justifyContent: "center",
                        marginBottom: "1rem", flexShrink: 0,
                      }}
                    >
                      <i
                        className={`fa ${ICONS[i % ICONS.length]}`}
                        style={{ color: "#fff", fontSize: 24 }}
                      />
                    </div>

                    <h3 style={{ fontSize: 17, fontWeight: 700, marginBottom: "0.75rem", color: "#1a1a1a" }}>
                      {page.h1 || page.title}
                    </h3>

                    <p style={{ color: "#666", fontSize: 14, lineHeight: 1.6, flex: 1, margin: 0 }}>
                      {page.meta_description
                        ? page.meta_description.length > 120
                          ? page.meta_description.slice(0, 117) + "…"
                          : page.meta_description
                        : "Professional cleaning service in Christchurch."}
                    </p>

                    <div style={{ marginTop: "1.25rem" }}>
                      <Link
                        to={`/${page.slug}`}
                        className="btn btn-dark btn-sm"
                        onClick={(e) => e.stopPropagation()}
                        style={{ borderRadius: 6, fontSize: 13, padding: "6px 18px" }}
                      >
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default ServicesDirectory;
